/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";
import { colors } from "../../../constants/colors";

/* Styles */
import styles from "./styles.js"

const Footer = props => {
  const { setShowModal, handleSaveModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={() => setShowModal(false)}
            type="default"
            className={classes.cancelBtn}
            text={<FormattedMessage id="peopleGrid.deleteAction.cancel"/>}
          />
        </Col>
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={classes.saveBtn}
            onClick={handleSaveModal}
            type="danger"
            text={<FormattedMessage id="traveler.details.leaveCompany.leave"/>}
            dataTestId="leavecompanysubmit"
            spinner={{
              name: "leaveCompanySpinner",
              size: 20,
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default Footer;
